"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BreakpointProvider = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _select = require("./select");

var _useBreakpointRuleMatch = require("./useBreakpointRuleMatch");

var _context = require("./context");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var BreakpointProviderComponent = function BreakpointProviderComponent(_ref) {
  var _ref$theme = _ref.theme,
      breakpoints = _ref$theme.breakpoints,
      upQuery = _ref$theme.media.upQuery,
      children = _ref.children;
  var upXXXSmall = (0, _useBreakpointRuleMatch.useBreakpointRuleMatch)(breakpoints.xxsmall, upQuery);
  var upXXSmall = (0, _useBreakpointRuleMatch.useBreakpointRuleMatch)(breakpoints.xxsmall, upQuery);
  var upXSmall = (0, _useBreakpointRuleMatch.useBreakpointRuleMatch)(breakpoints.xsmall, upQuery);
  var upSmall = (0, _useBreakpointRuleMatch.useBreakpointRuleMatch)(breakpoints.small, upQuery);
  var upMedium = (0, _useBreakpointRuleMatch.useBreakpointRuleMatch)(breakpoints.medium, upQuery);
  var upLarge = (0, _useBreakpointRuleMatch.useBreakpointRuleMatch)(breakpoints.large, upQuery);
  var upXLarge = (0, _useBreakpointRuleMatch.useBreakpointRuleMatch)(breakpoints.xlarge, upQuery);
  var upXXLarge = (0, _useBreakpointRuleMatch.useBreakpointRuleMatch)(breakpoints.xxlarge, upQuery);
  var upXXXLarge = (0, _useBreakpointRuleMatch.useBreakpointRuleMatch)(breakpoints.xxlarge, upQuery);
  var computedBreakpointRules = {
    upXXXSmall: upXXXSmall,
    downXXXSmall: !upXXXSmall,
    upXXSmall: upXXSmall,
    downXXSmall: !upXXSmall,
    upXSmall: upXSmall,
    downXSmall: !upXSmall,
    upSmall: upSmall,
    downSmall: !upSmall,
    upMedium: upMedium,
    downMedium: !upMedium,
    upLarge: upLarge,
    downLarge: !upLarge,
    upXLarge: upXLarge,
    downXLarge: !upXLarge,
    upXXLarge: upXXLarge,
    downXXLarge: !upXXLarge,
    upXXXLarge: upXXXLarge,
    downXXXLarge: !upXXXLarge
  };

  var breakpoint = _objectSpread(_objectSpread({}, computedBreakpointRules), {}, {
    select: (0, _select.makeSelect)(computedBreakpointRules)
  });

  return /*#__PURE__*/_react["default"].createElement(_context.BreakpointContext.Provider, {
    value: {
      breakpoint: breakpoint
    }
  }, children);
};

BreakpointProviderComponent.propTypes = {
  theme: _propTypes["default"].shape({
    breakpoints: _propTypes["default"].object.isRequired,
    media: _propTypes["default"].shape({
      upQuery: _propTypes["default"].func.isRequired
    }).isRequired
  }).isRequired
};
var BreakpointProvider = (0, _styledComponents.withTheme)( /*#__PURE__*/_react["default"].memo(BreakpointProviderComponent));
exports.BreakpointProvider = BreakpointProvider;